import React from 'react';
import '../assets/css/faq.css';

const FAQ = () => {
    const faqItems = [
        {
            question: "What are the winning amounts?",
            answer: "If your square holds the last two digits of the score you win!  Each quarter has a set prize amount: Q1 - $150, Q2 - $150, Q3 - $200, and the Final Score - $1,000."
        },
        {
            question: "What is My100Squares?",
            answer: "My100Squares is an interactive grid-based fundraiser to support the Maryland Express Softball Team. Participants purchase squares for a chance to win prizes based on the Super Bowl game's score."
        },
        {
            question: "How do I participate?",
            answer: "Select any available square on the grid, complete your purchase, and you're entered to win! Winners are determined by the final score of each quarter."
        },
        {
            question: "Where do the proceeds go?",
            answer: "All proceeds directly benefit the Maryland Express Softball Team, covering costs like tournament fees, equipment, and travel."
        },
        {
            question: "How are winners determined?",
            answer: "Numbers are assigned randomly to the rows and columns. Winners are selected based on the last digit of each team's score at the end of each quarter."
        },
    ];

    return (
        <div className="faq-container">
            <h1>Frequently Asked Questions</h1>
            <ul className="faq-list">
                {faqItems.map((item, index) => (
                    <li key={index} className="faq-item">
                        <h2>{item.question}</h2>
                        <p>{item.answer}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FAQ;